import { render, staticRenderFns } from "./ForumCatCover.vue?vue&type=template&id=04b6af58&scoped=true"
import script from "./ForumCatCover.vue?vue&type=script&lang=ts"
export * from "./ForumCatCover.vue?vue&type=script&lang=ts"
import style0 from "./ForumCatCover.vue?vue&type=style&index=0&id=04b6af58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6af58",
  null
  
)

export default component.exports